// React
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { translate } from "../../utils/translation";
import Modal, { AutoCloseModal } from "../modal/Modal";

// Components
import CreateProjectSelectProjectCostManagers from "../project-create/CreateProjectSelectProjectCostManagers";
import {
  ModalMultiple,
  DisplayErrors,
  Submit,
} from "../permissions/Permissions.components";
import isEmpty from "../../validation/is-empty";
import { useCollectionUsers } from "../../api/benchmarking/BenchmarkCollectionsAPI";
import Spinner from "../common/Spinner";
import { hasRoles } from "../../utils/roles";

BenchmarkCollectionsShare.propTypes = {
  user: PropTypes.object,
  setSelectedCollection: PropTypes.func,
  selectedCollection: PropTypes.object,
  benchmarkCollections: PropTypes.object,
};

export default function BenchmarkCollectionsShare(props) {
  const [isShareOpen, setIsShareOpen] = useState(false);

  const { user } = props;
  const { selectedCollection, setSelectedCollection } = props;
  const { benchmarkCollections } = props;

  if (hasRoles(user.roles, ["Client"])) {
    return <div className="hidden-button"></div>;
  }

  return (
    <div>
      <button
        className="button general-upload-button"
        onClick={() => {
          setIsShareOpen(!isShareOpen);
        }}
      >
        Share
      </button>
      <Modal
        title={translate("Share Collection")}
        Component={BenchmarkingCollectionsShareModal}
        modal={isShareOpen}
        setModal={setIsShareOpen}
        // Props
        benchmarkCollections={benchmarkCollections}
        selectedCollection={selectedCollection}
        setSelectedCollection={setSelectedCollection}
        user={user}
      />
    </div>
  );
}

BenchmarkingCollectionsShareModal.propTypes = {
  setModal: PropTypes.func,
  selectedCollection: PropTypes.object,
};

function BenchmarkingCollectionsShareModal(props) {
  const { selectedCollection } = props;
  const { setModal } = props;

  const { users } = useCollectionUsers(selectedCollection.id);

  // Selection Details
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!isEmpty(users.data)) {
      setSelectedUsers(users.data);
    }
  }, [users.data]);

  const data = {
    setError: setErrors,
    updateState: () => {
      setErrors({});
      AutoCloseModal(setModal);
    },
    project_leader: "",
    peer_reviewer: "",
    usersSelected: selectedUsers.map((c) => c.id),
    existingUsers: users.data,
    mappingId: selectedCollection.id,
    mappingType: "Benchmark",
    companyId: null,
  };

  if (users.loading) {
    return <Spinner></Spinner>;
  }

  return (
    <div className="pciu">
      <div className="pciu-form">
        <div className="pciu-panel-container">
          <div className="pciu-panel">
            Please select the users that can view this collection.
          </div>
        </div>

        <div className="pciu-panel-container">
          <div className="pciu-panel">
            <ModalMultiple
              Component={CreateProjectSelectProjectCostManagers}
              setFunction={setSelectedUsers}
              label={translate("Users")}
              selectedData={selectedUsers}
              userGroup={"all"}
            />
          </div>
        </div>
        <div className="general-row-container">
          <DisplayErrors error={errors} />
        </div>
        <Submit data={data} />
      </div>
    </div>
  );
}
